export class HoursComparison {
  constructor(coverage, dropoff, pickup, hours) {
    this.coverage = coverage
    this.dropoff = dropoff
    this.pickup = pickup
    this.hours = hours
  }

  resolve() {
    return this.coverage.every(function(day) {
      return this.hours.some(function(hours) {
        return (hours.day == day && hours.open <= this.dropoff && hours.close >= this.pickup)
      }, this)
    }, this)
  }
}
